module.exports = __webpack_public_path__ + "static/media/popup-close-icon.d2bc9337.svg";